<!--
单页面示例：统计项选择页面；
-->
<template>
  <scroll-right-frame class="demo-spage-4">
    <div class="rp-wrapper">
      <div class="rp-header">
        <span class="rp-header-title">招生数据统计</span>
      </div>
      <div class="rp-body">
        <el-alert type="info" title="说明" show-icon :closable="false"
          description="招生统计可以按照教学点、年级、专业、层次、班级多个维度，统计已注册学生、已注册正式生、已注册预科生、预科生转正情况，不选择条件默认统计整体情况。"
        ></el-alert>
        <el-alert type="info" title="" :closable="false">
          <p class="el-alert__description" style="font-size: 13px; font-weight: bold;">
            请在下方选择您需要的统计项：
          </p>
        </el-alert>
        <div class="rp-form">
          <div style="margin-top: 20px">
            <el-checkbox style="margin-left: 10px;"
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkedItems" size="small" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="item in items" :label="item" :key="item" border>{{ item }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="submit-btn">
            <button class="btn btn-solid" @click="handleSubmit">确定</button>
            <button class="btn btn-hollow">取消</button>
          </div>
        </div>
      </div>
    </div>
  </scroll-right-frame>
</template>
<script>
  import ScrollRightFrame from '../../../components/scroll-right-frame'
  export default {
    name: 'demo-spage-4',
    components: {ScrollRightFrame},
    data() {
      return {
        checkAll: false,
        checkedItems: ['教学点', '年级'],
        items: ['教学点', '年级', '专业', '层次', '班级', '民族', '政治面貌', '学习形式', '性别'],
        isIndeterminate: true
      }
    },
    methods: {
      handleCheckAllChange(val) {
        this.checkedItems = val ? this.items : []
        this.isIndeterminate = false
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length
        this.checkAll = checkedCount === this.items.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.items.length
      },
      handleSubmit() {
        this.$alert(this.checkedItems)
      }
    }
  }
</script>
<style lang="scss">
  .demo-spage-4 {
    .rp-form {
      margin-top: 10px;
      border: none;
    }
    .submit-btn {
      margin-top: 30px;
    }
    .btn-hollow {
      margin-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/demo/demo-spage-4.vue